exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/academic-career-goals/academic-career-goals.component.css
// module id = ../../../../../src/app/pages/profile/academic-career-goals/academic-career-goals.component.css
// module chunks = main